import { action, computed, observable, makeObservable } from 'mobx';
import { RemoteResourceV3, updateRemoteResourceV3 } from '../../../../../commonv3/api/RemoteResourceV3';
import { PaymentIndexView } from '../../../../types/payments';
import { PaymentApis } from '../../../../apis/payments';
import { CardSummary } from '../../../../../mainv2/types/card';
import { UserApis } from '../../../../../mainv2/api';
import { Service } from '../../../../../commonv3/types/service';

export class PaymentListPaneState {
  cardSummary: RemoteResourceV3<CardSummary> = RemoteResourceV3.loading();
  payments: RemoteResourceV3<PaymentIndexView[]> = RemoteResourceV3.loading();

  constructor() {
    makeObservable(this, {
      cardSummary: observable,
      payments: observable,
      init: action.bound,
      loading: computed,
      reloadPayments: action.bound,
      reloadCardSummary: action.bound,
    });
  }

  async init() {
    await this.reloadPayments();
    await this.reloadCardSummary();
  }

  get loading() {
    return this.cardSummary.loading || this.payments.loading;
  }

  async reloadPayments() {
    await updateRemoteResourceV3(
      this.payments,
      (v) => (this.payments = v),
      () => PaymentApis.findAll([Service.LIKES])
    );
  }

  async reloadCardSummary() {
    await updateRemoteResourceV3(
      this.cardSummary,
      (v) => (this.cardSummary = v),
      () => UserApis.getCurrentCard()
    );
  }
}
